<template>
    <div class="section" id="voted">
        <h3>{{ title }}</h3>
        <div class="section-box">
            <div
                class="infogram-embed"
                data-id="f594e031-9bcf-4cda-b5c7-e97e8caafd51"
                data-type="interactive"
                data-title="罷免林昶佐 - 歷年投票"
            ></div>

            <div
                style="padding:8px 0;font-family:Arial!important;font-size:13px!important;line-height:15px!important;text-align:center;border-top:1px solid #dadada;margin:0 30px"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            title: '歷屆台北第五選區選舉結果',
        }
    },
}
</script>

<style scoped></style>
